/**
 * 
 * key
 * 
 */


const key = 'Y3JtV2lzZVByb2R1Y3RTdGF0dXNBZ2luZ1JlcG9ydA=='

export default key 